export default __webpack_public_path__ + "static/media/inactiveCalendar.f78396ab.svg";